import { IParamsCreateComponent } from '@/courses/interfaces/params-create-component.interface';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit } from 'vue-property-decorator';

@Component({name: 'ed-select-component-course', components: {}})
export default class EdSelectComponentCourseComponent extends Vue {
  
  @Prop() readonly eduacComponents: any[];
  @Prop() readonly componentSelected: IParamsCreateComponent;
  @Prop() readonly courseId: number;
  @Prop() readonly classId: number;

  isDeleteComponentConfirmModalShown: boolean = false;
  itemSelected: any = {};
  selectedChip = null;

  @Emit('onChangeComponent')
  onChangeComponent(data) {
    return data;
  }

  get canSelect() {
    return (this.componentSelected) ? false : true;
  }

  changeComponent(item) {
    this.onChangeComponent(item);
  }

  showCustomizeComponents() {
    this.$edEventBus.$emit('openComponentsModal');
  }

  mounted() {
    this.selectedChip = this.$attrs.value;
    this.$edEventBus.$on('updateSelected', this.updateSelected)
  }

  destroyed() {
    this.$edEventBus.$off('updateSelected')
  }

  beforeUpdate() {
    if (!this.canSelect) {
      this.selectedChip = this.componentSelected;
    }
  }


  toggleChip(value) {
    if (this.canSelect) {
      this.selectedChip = value;
      this.$emit('input', this.selectedChip);
    }
  }

  updateSelected() {
    this.selectedChip = this.$attrs.value;
  }
}